import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';

const isFirstActiveWithinLast30Days = (firstActiveDate: string): boolean => {
	const date = new Date(firstActiveDate);
	if (Number.isNaN(date.getTime())) {
		return false;
	}
	const thirtyDaysAgo = new Date();
	thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
	return date >= thirtyDaysAgo;
};

export const usePassesIPHTargetingTraitsSelector = createTraitsSelector(
	'SITE_USER',
	({ getTraitByName }) => {
		// First check the most common case:
		const hasCreatedIssueInGICTrait = getTraitByName(
			'jira-core_ui_button_clicked_createissue_createissuemodal_first_time',
		);
		if (hasCreatedIssueInGICTrait) {
			return false;
		}
		const hasDismissedCreateIssueVideoBannerTrait = getTraitByName(
			'jira-core_ui_button_clicked_dismisscreateworkvideoeducationbanner_createissuemodal_first_time',
		);
		if (hasDismissedCreateIssueVideoBannerTrait) {
			return false;
		}
		const hasOpennedCreateIssueVideoModalTrait = getTraitByName(
			'jira-core_ui_button_clicked_opencreateworkvideoeducationmodal_createissuemodal_first_time',
		);
		if (hasOpennedCreateIssueVideoModalTrait) {
			return false;
		}
		// less common especially if any above traits are true
		const firstActiveTrait = getTraitByName('jira_first_active');
		if (
			firstActiveTrait &&
			typeof firstActiveTrait.value === 'string' &&
			!isFirstActiveWithinLast30Days(firstActiveTrait.value)
		) {
			return false;
		}
		return true;
	},
);
